import { UserType } from '../cognito/user.types';

export enum AuditLogAction {
  Insert = 'insert',
  Update = 'update',
  Delete = 'delete',
}

export interface AuditLogActorType {
  userType: UserType;
  userId: string;
  username: string;
  restaurantId: number;
  businessId: number;
}

export interface AuditLogEntityType {
  id?: number | string;
  name?: string;
  action?: AuditLogAction;
}

export interface AuditLogActionType {
  entity: AuditLogEntityType[];
}
